import DefaultTheme from 'assets/themes/default';
const VariationTheme5 =  JSON.parse(JSON.stringify(DefaultTheme));

VariationTheme5.palette.primary.main='#1ed2f4'
delete VariationTheme5.palette.primary.dark;
VariationTheme5.community.communityNameColor = '#1ed2f4';
VariationTheme5.community.defaultBannerImg = 'https://www.clippergroup.co.uk/wp-content/uploads/2019/07/future-forum-header.jpg';
export default VariationTheme5;